import { KUBER_BFF_PREFIX } from '.';

export const API_URLS = {
  getDocumentList:
    '/api/verification-modification/component-and-document-type?verificationRequestId=#{verificationRequestId}&claimId=#{claimId}',
  GET_COUNTRY: `/api/verification-initiation/countries`,
  COUNTRY_ICONS: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country`,
  getClientRequirementListTabs: `/api/client-requirement/client-requirement-list-tabs?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&tabId=#{tabId}`,
  getClientRequirementListTabData: `/api/client-requirement/client-requirement-list-tab-data?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&tabId=#{tabId}`,
  postClientRequirementListsResponseTab: `/api/client-requirement/client-requirement-response-tab`,
  postClientRequirementDocumentsTab: `/api/client-requirement/client-requirement-document-tab`,
  validateField: `/api/client-requirement/validate-field?verificationRequestId=#{verificationRequestId}`,
  registerUsertoken: `/api/mobile-app/userToken`,
  getActiveFeatureConfig: `/api/config/active-features`,
  getApplicantDashboardNavItems: `/api/config/applicantDashboardNav`,
  getNonAuthDashboardNavItems: `/api/config/nonAuthApplicantDashboardNavConfig`,
  getLetter: `/api/letter-of-auth?verificationRequestId=#{verificationRequestId}`,
  generateLoaOtp: `/api/letter-of-auth/generate-otp`,
  verifyLetterOfAuth: `/api/letter-of-auth/verify-otp`,
  getUserById: `/api/user/#{userId}`,
  getUser: `/api/user`,
  updateUserById: `/api/user/#{userId}`,
  navigationDashboardRoute: '/dashboard/home',
  logInUrl: `/api/onboarding/login/otp`,
  verifyPreAuthCode: `/api/onboarding/verify-preAuth-code?code=#{code}&userType=#{userType}`,
  getUaePassLogInDetails: `/api/verification-creation/authenticate-uae-pass-user?code=#{code}`,
  resendOtp: `/api/onboarding/resend/otp`,
  sendMobileOtp: `/api/onboarding-mobile/mobile/otp`,
  verifyMobileOtp: `/api/onboarding-mobile/mobile/otp/verify`,
  generateCaptcha: `/api/onboarding/captcha`,
  getS3DocumentUrls: `/api/verification-creation/pre-signed-urls?fileIds=#{fileIds}`,
  logOutUrl: `/api/onboarding/logout`,
  emailUrl: `/api/onboarding-email/add`,
  logInOtpVerify: `/api/onboarding/login/otp/verify`,
  emailVerify: `/api/onboarding-email/verify`,
  getAboutYourself: `/api/onboarding-applicant/config`,
  getNationalityDetails: `/api/config/nationalities`,
  getClientContract: `/api/verification-initiation/new-client-contract?clientId=#{clientId}&purposeId=#{purposeId}&purposeCategoryId=#{purposeCategoryId}&countryCode=#{countryCode}&applicantId=#{applicantId}`,
  getClientContractByVRId: `/api/verification-initiation/new-client-contract?verificationRequestId=#{verificationRequestId}&applicantId=#{applicantId}`,
  createVerification: `/api/verification-creation/create`,
  getVerificationStatus:
    '/api/verification-details/status/#{verificationRequestId}',
  getHome: '/api/home-dashboard',
  getHomeDashboard: '/api/home-dashboard/dashboard',
  getHomePurposes: '/api/home-dashboard/purposes',
  getCredentials: `/api/credentials/get-credentials?component=#{component}`,
  deleteCredential: `/api/credentials/delete-credential`,
  addCredentials: `/api/credentials/get-credentials-list?component=#{component}`,
  updateCredentials: `/api/add-credential`,
  getVerificationDetailsById: `/api/verification-details/verification-request/#{verificationId}?fetchApplicant=#{fetchApplicant}`,
  getPaymentPackageDetailsFromVR: `/api/verification-details/get-payment-package-details/#{verificationRequestId}`,
  getRefundPayoutsByVRId:
    '/api/payments/get-refund-by-vr/#{verificationRequestId}',
  getVerificationDetailsByCaseId:
    '/api/verification-details/verification-details-by-case-id?caseId=#{caseId}&fetchApplicant=#{fetchApplicant}',
  cancelVerification: '/api/verification-creation/cancel',
  getVerification: '/api/verification-dashboard',
  verificationInsuffiency:
    '/api/verification-modification/insufficiency?verificationId=#{verificationId}',
  getUserProfile: '/api/user-profile',
  updateUserProfile: '/api/user-profile/update',
  notifications: '/api/notifications',
  updateReadStatus: '/api/notifications/updateReadStatus',
  notificationsStatus: '/api/notifications/getNotificationsStatus',
  updateInsufficiency: '/api/verification-modification/insufficiency',
  startVerification: '/api/verification-initiation/verification/start',
  updateBulkUploadParentDocuments:
    '/api/verification-initiation/verification/case-creation',
  postSignedLetter: `/api/verification-sign-letter`,
  updateVerificationRequest:
    '/api/verification-creation/verification-request?verificationRequestId=#{verificationRequestId}',
  getIaListDetailsByName: `/api/ia-selection/list?name=#{name}&iaStatus=#{iaStatus}&iaOfficeId=#{iaOfficeId}`,
  startPaymentTransaction:
    '/api/payments/start-payment-transaction?subDomain=#{subDomain}',
  getPaymentTransactionDetails:
    '/api/payments/payment-transaction-details?paymentTransactionId=#{paymentTransactionId}&verificationRequestId=#{verificationRequestId}',
  getPlaceAutocomplete: '/api/location/place-autocomplete?query=#{query}',
  getPlaceDetails: '/api/location/place',
  getNotificationPrefrences: '/api/applicant-setting/notification-preferences',
  putNotificationPreferences:
    '/api/applicant-setting/update-notification-preferences',
  getMrl:
    '/api/verification-mrl?officeId=#{officeId}&componentId=#{componentId}&applicantUserId=#{applicantUserId}',
  updateSignedLetter: '/api/verification-sign-letter',
  getCtaTokenDetails: `/api/cta-token/details?token=#{token}`,
  getApplicantVRTransactions: `/api/applicant-vr-transactions`,
  errorLog: '/api/log',
  getSupportConfig: '/api/cosmos/support-config',
  getSubmitApplicationDetailsByVr: `/api/verification-details/submit-application-details?verificationRequestId=#{verificationRequestId}`,
  deleteVerificationRequest:
    '/api/verification-modification/verification?verificationRequestId=#{verificationRequestId}',
  reInviteApplicant: '/api/invite-applicant/re-invite',
  additionalAuthConfig:
    '/api/verification-creation/additonal-auth-config?state=#{state}&type=#{type}',
  getCaseHistoryOfVR:
    '/api/verification-details/case-history?verificationRequestId=#{verificationRequestId}',
  sendVRForApproval:
    '/api/verification-details/send-vr-for-approval/#{verificationRequestId}',
  getWorkflowStageHistory: `/api/verification-details/workflow-stage-history?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}&endTimeStamp=#{endTimeStamp}`,
  updateLatestPartnerAdminResponse:
    '/api/verification-details/update-latest-partner-admin-response/#{verificationRequestId}',
  verificationOverview:
    '/api/verification-creation/verification-overview?verificationRequestId=#{verificationRequestId}',
  transferOwnership: '/api/fetch-report/transfer-ownership',
  getVerificationRequestListForAdditionalComponent:
    '/api/verification-details/verification-list?applicantId=#{applicantId}&clientId=#{clientId}',
  getVerificationResumeUrl:
    '/api/verification-creation/verification-resume-url?verificationRequestId=#{verificationRequestId}',
  getOfficeDetails: `/api/verification-creation/iaOfficeDetails/?officeId=#{officeId}`,
  getLegacyCaseAppealUrl:
    '/api/verification-modification/legacy-case-appeal-url?caseId=#{caseId}',
  executeRenewalCasePrecondition:
    '/api/verification-creation/execute-renewal-case-precondition?clientId=#{clientId}&applicantUserId=#{applicantUserId}&clientContractId=#{clientContractId}',
  getPlatformPreferenceForCoBrandDetails: `/api/config/platform-preferences?url=#{url}&platformType=#{platformType}`,
  parseFile: '/api/verification-creation/file/data',
  getResourceAccess: '/api/resource-access',
  queryUserRequest: '/api/user/applicant-query',
  /** Garuda → Aria Vincent session end (POST body: sessionId, endTime, feedback) */
  applicantEndSession: '/api/user/applicant-end-session',
  getVDTabContent:
    '/api/verification-details/applicant/tabs/#{tabKey}?verificationRequestId=#{verificationRequestId}',
  getVDTabContentByCaseId:
    '/api/verification-details/applicant/tabs/#{tabKey}?caseId=#{caseId}',
  getVDInsufficiency:
    '/api/verification-details/applicant/insufficiency?verificationRequestId=#{verificationRequestId}',
  getVDInsufficiencyByCaseId:
    '/api/verification-details/applicant/insufficiency?caseId=#{caseId}',
  getVDTabConfig:
    '/api/verification-details/applicant/tab-config?verificationRequestId=#{verificationRequestId}',
  getVDTabConfigByCaseId:
    '/api/verification-details/applicant/tab-config?caseId=#{caseId}',
  getVDCaseHistoryStageDetail:
    '/api/verification-details/applicant/case-history-stage-detail?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}'
};

export const LEAD_MANAGEMENT_API_URLS = {
  getAdDetails: `/${KUBER_BFF_PREFIX}/ads/details/#{adId}`,
  getAllAdsSummary: `/${KUBER_BFF_PREFIX}/ads/summary?source=#{source}`,
  getCategories: `/${KUBER_BFF_PREFIX}/categories/?source=#{source}`,
  getAdsSummaryByCategory: `/${KUBER_BFF_PREFIX}/ads/category/#{categoryId}/summary`,
  postInitiateOrderPayment: `/${KUBER_BFF_PREFIX}/orders/initiate-payment`,
  createOrder: `/${KUBER_BFF_PREFIX}/orders/`,
  getAncillaryPaymentStatusDetails: `/${KUBER_BFF_PREFIX}/orders/payment-status/#{orderId}`,
  getAncillaryPaymentBreakdown: `/${KUBER_BFF_PREFIX}/orders/payment-breakdown/#{orderId}`,
  getAncillaryTransactions: `/${KUBER_BFF_PREFIX}/orders/payment-transactions/#{orderId}`,
  markCalendlySlotBooked: `/${KUBER_BFF_PREFIX}/orders/calendly-slot-booked/#{orderId}`,
  submitIntent: `/${KUBER_BFF_PREFIX}/ads/submit-intent`,
  postInitiateAdditionalOrderPayment: `/${KUBER_BFF_PREFIX}/orders/initiate-additional-payment?orderPaymentId=#{orderPaymentId}`,
  getAncillaryInterstitial: `/${KUBER_BFF_PREFIX}/ads/ancillary-interstitial?source=#{source}`
};

export const VERIFICATION_API_URLS = {
  getVerificationOverview: `/api/verification-creation/overview`,
  getVerificationOverviewSummary: `/api/verification-details/overview-summary?verificationRequestId=#{verificationRequestId}`,
  claimItems: '/api/verification-creation/claim-items',
  claimItemsForContract:
    '/api/verification-creation/claim-items?contractId=#{contractId}',
  completeInitialClaim: '/api/verification-creation/complete-initial-claim',
  getVerifiableComponents: `/api/verification-creation/verifiable-components?verificationRequestId=#{verificationRequestId}`,
  addSingleVerifiableComponent: `/api/verification-creation/verifiable-component`,
  deleteSingleVerifiableComponent: `/api/verification-creation/verifiable-component`,
  getIssuersData: `/api/verification-creation/issuers-data?verificationRequestId=#{verificationRequestId}`,
  updateIssuersForClaim: `/api/verification-creation/update-issuers-for-claim`,
  extractFile:
    '/api/verification-creation/file/extract-attributes/?fileId=#{fileId}',
  moveToVerification: '/api/verification-creation/move-to-verification',
  getAppealDetails:
    '/api/verification-modification/appeal-details?verificationRequestId=#{verificationRequestId}&caseId=#{caseId}',
  getRequestCorrectionDetails:
    '/api/verification-modification/request-correction-details?verificationRequestId=#{verificationRequestId}&caseId=#{caseId}',
  raiseAppealError:
    '/api/verification-modification/raise-appeal-error?subDomain=#{subDomain}',
  createDiscrepantId:
    '/api/facet-intelligence/name-change-data?verificationRequestId=#{verificationRequestId}',
  createNameChangeComponent:
    '/api/verification-initiation/create-discrepant-component?verificationRequestId=#{verificationRequestId}',
  deleteNameChangeComponent:
    '/api/verification-initiation/delete-discrepant-component',
  getPricingDetails:
    '/api/price-details/pricing-details?verificationRequestId=#{verificationRequestId}&screenType=#{screenType}',
  getAppealPricingDetails:
    '/api/price-details/appeal-pricing?verificationRequestId=#{verificationRequestId}',
  getFetchReportPricingDetails:
    '/api/price-details/fetch-report-pricing?verificationRequestId=#{verificationRequestId}',
  getFetchReportReissuePricingDetails:
    '/api/price-details/fetch-reissue-report-pricing?verificationRequestId=#{verificationRequestId}',
  getReportTransfer: `/api/verification-initiation/report-transfer?verificationRequestId=#{verificationRequestId}`,
  getReportDocumentDetails: `/api/fetch-report/report-document-details?documentId=#{documentId}`,
  getExistingReports: `/api/fetch-report/existing-reports?passportNo=#{passportNo}&dob=#{dob}&email=#{email}&phoneNo=#{phoneNo}&clientContractId=#{clientContractId}`,
  postReportTransfer: '/api/verification-initiation/report-transfer',
  postReportSharing: '/api/verification-initiation/report-sharing',
  createReportTransferComponent:
    '/api/verification-creation/report-transfer-component',
  getVerificationRequestPricingDetails: `/api/price-details/verification-request-pricing?verificationRequestId=#{verificationRequestId}`,
  getInsufficiencyPricingDetails:
    '/api/price-details/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  postPricingDetails: '/api/price-details/pricing-details',
  getSpeciality: `/api/verification-initiation/all-purpose-categories?clientId=#{clientId}&countryCode=#{countryCode}&omitContractType=#{omitContractType}`,
  verificationOverviewPdf: '/api/verification-details/overviewPdf',
  deleteClaims: '/api/verification-modification/delete-claims',
  replaceClaimItem: '/api/verification-modification/replace-claim-item',
  replaceClaimItemV2: '/api/verification-modification/replace-claim-item-v2',
  postMRLInsufficiencyAction:
    '/api/verification-modification/mrlInsufficiency?verificationRequestId=#{verificationRequestId}',
  updateSupportingDocumentDetails:
    '/api/verification-modification/supporting-document-details',
  postReissueReportPaymentContract:
    '/api/price-details/post-reissue-report-payment-contract?verificationRequestId=#{verificationRequestId}',
  getReIssueReportPaymentDetails: `/api/verification-details/reissue-report-payment`,
  getRTFlowMetadata: `/api/verification-creation/rt-flow-metadata`,
  getApplicantDOB: `/api/user/applicant/dob`,
  detectAutoInsufficiency:
    '/api/verification-details/detect-auto-insufficiency?verificationRequestId=#{verificationRequestId}',
  submitDocumentClassificationFeedbackModalEligibility:
    '/api/verification-details/submit-document-classification-feedback-modal-eligibility?verificationRequestId=#{verificationRequestId}',
  submitDocumentClassificationFeedback:
    '/api/verification-details/submit-document-classification-feedback',
  detectDuplicateComponents:
    '/api/verification-creation/detect-duplicate-components',
  initiatePreValidation:
    '/api/verification-details/initiate-pre-validation?verificationRequestId=#{verificationRequestId}',
  getClaimDocumentsByVrId:
    '/api/verification-creation/get-claim-documents?verificationRequestId=#{verificationRequestId}',
  extractDocumentLlm: '/api/verification-creation/extract-document-type',
  /** GET auto-doc mismatch case-detail insufficiency flag for instant feedback (VR-scoped). */
  getAutoDocMismatchCaseDetailsInsufficiency:
    '/api/verification-details/case-detail-insufficiency?verificationRequestId=#{verificationRequestId}'
};

export const VERIFICATION_UPLOAD_API_URLS = {
  getComponentsDetails:
    '/api/verification-creation/components?verificationRequestId=#{verificationRequestId}&filteredComponentTypeIds=#{filteredComponentTypeIds}',
  getAdditionalSteps:
    '/api/verification-creation/additional-components?verificationRequestId=#{verificationRequestId}&isParent=#{isParent}&clientContractId=#{clientContractId}',
  getComponent:
    '/api/verification-creation/component?componentId=#{componentId}&verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  componentUrl: '/api/verification-creation/component',
  documentUrl: '/api/verification-creation/document',
  addAdditionalComponent: '/api/verification-creation/additional-components',
  getNameChangeGaps:
    '/api/facet-intelligence/name-change-gaps?verificationRequestId=#{verificationRequestId}',
  getDepartmentCourseByComponentId:
    '/api/verification-creation/get-department-course?componentId=#{componentId}&iaOfficeId=#{iaOfficeId}'
};

export const CREDENTIALS_SUBSCRIPTION_API_URLS = {
  getSubscriptionPaymentBreakdown: `/api/credentials-subscription/payment-breakdown?planId=#{planId}`,
  cancelSubscription: `/api/credentials-subscription/cancel-subscription?subscriptionId=#{subscriptionId}`,
  getAllSubscriptionPlans: `/api/credentials-subscription/subscription-plans`,
  getSubscriptionByUserId: `/api/credentials-subscription/subscription`,
  createSubscription: '/api/credentials-subscription/create-subscription',
  createSubscriptionPaymentContract:
    '/api/credentials-subscription/create-subscription-payment-contract',
  getSubscriptionBySubscriptionId:
    '/api/credentials-subscription/subscription-by-subscriptionId?subscriptionId=#{subscriptionId}',
  getVaultCredentials: '/api/credentials-subscription/credentials',
  getCredentialsDetails:
    '/api/credentials-subscription/credentials-details?credentialId=#{credentialId}',
  validateTrueProof: '/api/credentials-subscription/validate-pdf',
  validatePublicTrueProof: `${process.env.NEXT_PUBLIC_CREDENTIALS_SERVICE_URL}/validateTrueProof-pdf`,
  getCredentialReport:
    '/api/credentials-subscription/credential-report?credentialId=#{credentialId}',
  getPaymentOverviewBreakdown:
    '/api/credentials-subscription/payment-overview-breakdown?subscriptionId=#{subscriptionId}',
  getShareCredentialConsent:
    '/api/credentials-subscription/share-credential-consent',
  generateCredentialSignedUrl:
    '/api/credentials-subscription/generate-credential-signed-url'
};

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;
